import { TWhatDoYouLikeValues } from '../../../../vision-profile-views/what-do-you-like-view/what-do-you-like-form';

export const isAllFieldsEmpty = (values: TWhatDoYouLikeValues) => {
  const { whatDoYouLikeCustom, whatDoYouLikePredefined } = values;
  return !(whatDoYouLikeCustom || whatDoYouLikePredefined?.length);
};
